import { render } from "./lives.vue?vue&type=template&id=ba3606a4"
import script from "./lives.vue?vue&type=script&lang=js"
export * from "./lives.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__